import { useState } from "react";
import { useAuth, API } from "@/App";
import axios from "axios";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Eye, EyeOff, Zap } from "lucide-react";

export default function AuthPage() {
  const { login } = useAuth();
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (isLogin) {
        const res = await axios.post(`${API}/auth/login`, { email, password });
        login(res.data.token, res.data.user);
        toast.success("Sikeres bejelentkezés!");
      } else {
        const res = await axios.post(`${API}/auth/register`, { email, password, name });
        login(res.data.token, res.data.user);
        toast.success("Sikeres regisztráció! Demo adatok betöltve.");
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || "Hiba történt");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen auth-bg flex items-center justify-center px-4">
      <div className="w-full max-w-md fade-in-up">
        {/* Logo */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 mb-4">
            <Zap className="text-[#00f260]" size={32} strokeWidth={2.5} />
          </div>
          <h1 className="font-heading text-5xl font-bold tracking-wider text-white mb-2">
            Athlevity
          </h1>
          <p className="text-gray-400 text-sm tracking-wider uppercase">
            Performance &middot; Longevity &middot; Life
          </p>
        </div>

        {/* Auth card */}
        <div className="glass-card p-8" data-testid="auth-card">
          <h2 className="font-heading text-2xl font-semibold text-white mb-6">
            {isLogin ? "Bejelentkezés" : "Regisztráció"}
          </h2>

          <form onSubmit={handleSubmit} className="space-y-5">
            {!isLogin && (
              <div className="space-y-2 fade-in-up">
                <Label className="text-gray-400 text-sm">Név</Label>
                <Input
                  data-testid="auth-name-input"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Teljes neved"
                  className="bg-black/20 border-white/10 text-white placeholder:text-gray-500 focus:border-[#00f260] focus:ring-[#00f260] rounded-xl h-12"
                  required={!isLogin}
                />
              </div>
            )}

            <div className="space-y-2">
              <Label className="text-gray-400 text-sm">Email</Label>
              <Input
                data-testid="auth-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="email@pelda.hu"
                className="bg-black/20 border-white/10 text-white placeholder:text-gray-500 focus:border-[#00f260] focus:ring-[#00f260] rounded-xl h-12"
                required
              />
            </div>

            <div className="space-y-2">
              <Label className="text-gray-400 text-sm">Jelszó</Label>
              <div className="relative">
                <Input
                  data-testid="auth-password-input"
                  type={showPw ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Jelszó"
                  className="bg-black/20 border-white/10 text-white placeholder:text-gray-500 focus:border-[#00f260] focus:ring-[#00f260] rounded-xl h-12 pr-12"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPw(!showPw)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-300"
                >
                  {showPw ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            <button
              data-testid="auth-submit-btn"
              type="submit"
              disabled={loading}
              className="neon-btn w-full text-center text-sm"
            >
              {loading ? (
                <span className="flex items-center justify-center gap-2">
                  <span className="w-4 h-4 border-2 border-black border-t-transparent rounded-full animate-spin" />
                  Betöltés...
                </span>
              ) : isLogin ? "BEJELENTKEZÉS" : "REGISZTRÁCIÓ"}
            </button>
          </form>

          <div className="mt-6 text-center">
            <button
              data-testid="auth-toggle-btn"
              onClick={() => setIsLogin(!isLogin)}
              className="text-gray-400 text-sm hover:text-[#00f260] transition-colors"
            >
              {isLogin ? "Még nincs fiókod? Regisztrálj!" : "Már van fiókod? Jelentkezz be!"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
